export default {
      id: "external-link-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#external-link",
      toString: function () {
        return this.url;
      }
    }